import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios' // remove comment if yu needed
import app from '../../main'
import Crud from '../crud'
import checkResponse from '@/utils/checkResponse'
const model = (payload) => ({
  // columns
  id: payload.id,
  name: payload.name,
  business_name: payload.business_name,
  phone: payload.phone,
  email: payload.email,
  rfc: payload.rfc,
  address: payload.address,
  has_credit: payload.has_credit
})
var crud = new Crud('Suppliers', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  suppliers: [],
  isModalContactsSupliersVisible: false
}

const mutations = {
  ...crud.mutations,
  SET_MODAL_CONTACT_SUPPLIERS_VISIBLE (state, payload) {
    state.isModalContactsSupliersVisible = payload
  },
  UPDATE_RECORD (state, payload) {
    const idx = state.suppliers.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.suppliers, idx, payload)
    }
  }
}

const actions = {
  ...crud.actions,
  async addContact ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.post('contacts', payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_MODAL_CONTACT_SUPPLIERS_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.contacts', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async editContact ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put('contacts', payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'purchase_orders.purchase_order_details', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  setModalContactsSuppliersVisible ({ commit }, payload) {
    commit('SET_MODAL_CONTACT_SUPPLIERS_VISIBLE', payload)
  },
  setModalSupplierInvoicesVisible ({ commit }, payload) {
    commit('SupplierInvoices/SET_MODAL_VISIBLE', payload, { root: true })
  }
}

const getters = {
  ...crud.getters,
  suppliers: state => state.suppliers,
  isModalContactsSupliersVisible: state => state.isModalContactsSupliersVisible

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
